














































import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';

@Component({
  name: 'create-form',
  components: {
  },
  model: {
    prop: 'dialogVisible',
    event: 'update',
  },
})
export default class Products extends Vue {
  @Prop({ default: false }) public dialogVisible!: boolean;

  private currentStep = 0;

  private form = {
    name: '',
  }

  private listAccessories: any[] = [];

  private dataAccessories: any[] = [];

  private formAccessories: any[] = [];

  @Watch('listAccessories')
  protected onListAccessoriesChange(value: any[]): void {
    const form = value.map((item: string) => {
      const [id, name] = item.split('@#');
      return {
        linhkienId: id,
        name,
        soluong: 0,
      };
    });
    this.formAccessories = form;
  }

  protected async created() {
    await this.fetchAccessories();
  }

  private async fetchAccessories() {
    const res = await this.$api.accessories.getListAccessories();
    const input = res.map((item: any) => ({ key: `${item.id}@#${item.name}`, label: item.name }));
    this.dataAccessories = input;
  }

  private handleFormSubmit() {
    this.$emit('submit', { ...this.form, lksp: this.formAccessories });
    this.listAccessories = [];
    this.form.name = '';
    this.formAccessories = [];
    this.currentStep = 0;
  }

  private onTriggerClose() {
    this.$emit('update', false);
  }

  private handleNext() {
    this.currentStep += 1;
  }

  private handleBack() {
    this.currentStep -= 1;
  }
}
